// extracted by mini-css-extract-plugin
module.exports = {"swipeContainer":"PinchPanContainer_swipeContainer__uNFE8","pinchPanContainer":"PinchPanContainer_pinchPanContainer__2GTbz"};